var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('login-with-linkedin',{on:{"handleLogin":function($event){return _vm.login('linkedin')}}}),_vm._v(" "),_c('login-with-google',{on:{"handleLogin":function($event){return _vm.login('google')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }